import TimeFormatter from '../../../../helpers/TimeFormatter';
import {
    IMovieUrlArgs,
    makeVideoDownloadUrl,
} from '../../../../services/discovery/_shared/urlMakers';
import { IPlayerSettings } from '../../../../state/ui/discoverySlice';
import { CAMERAS_RANGE } from '../../../../constants/videoPlayerSettings';

interface GetMovieDownloadUrlParams {
    paramName: string;
    hls?: boolean;
    sliderTimeRange: number[];
    playerSettings: IPlayerSettings | null;
    isInFrameContext: boolean;
    date: string | null;
    monitoredId: string | null;
    elementId?: string | null;
}

export const getMovieDownloadUrl = ({
    paramName,
    hls,
    sliderTimeRange,
    playerSettings,
    isInFrameContext,
    date,
    monitoredId,
    elementId,
}: GetMovieDownloadUrlParams): string => {
    const { labels, model, confidenceThreshold, anonymize } =
        playerSettings ?? {};
    const genericMovieUrlParams = {
        sliderTimeRange: sliderTimeRange || CAMERAS_RANGE,
        paramName,
        anonymize,
        hls,
        labels,
        model,
        confidenceThreshold,
    };
    if (isInFrameContext && date && monitoredId) {
        const localDate = TimeFormatter.toLocalDate(date);
        const frameUrlParams: IMovieUrlArgs = {
            ...genericMovieUrlParams,
            monitoredId,
            eventDate: localDate,
        };

        return makeVideoDownloadUrl(frameUrlParams).toString();
    }

    const archiveUrlParams: IMovieUrlArgs = {
        ...genericMovieUrlParams,
        eventId: elementId || undefined,
    };
    return makeVideoDownloadUrl(archiveUrlParams).toString();
};
